import React from 'react';
import DocumentTable from './table';
import Navbar from '../navbar';
import { getMeta, loadAssociatedDocuments } from '../../api/external';
import AuthService from '../externalauthentication/authservice';
import { getThumbnail, loadDocument } from '../../api/external';
import { isModernApi } from '../../index';
import jwt from 'jsonwebtoken';

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.auth = new AuthService();
    this.state = {
      documents: [],
      meta: {}
    };
  }

  async componentDidMount() {
    console.log('table did mount');

    console.log('created auth');
    const user = await this.auth.getUser();
    console.log('show user');
    console.log(user);
    let documents = [];
    let meta = {};
    if (isModernApi()) {
      const token = jwt.decode(user.access_token);
      const docIds = token.s_documents;
      console.log('docIds', docIds);
      for (const id of docIds) {
        console.log('id', id);
        documents.push(await loadDocument(user, id));
      }
      meta = await getMeta(user);
    } else {
      documents = await loadAssociatedDocuments(user);
    }
    let images = {};
    if (documents && documents.length > 0) {
      for (let i = 0; i < documents.length; i++) {
        const document = documents[i];
        const thumb = await getThumbnail(user, document.id);
        if (isModernApi()) {
          images[document.id] = thumb;
        } else {
          images[document.id] = this.toBase64(thumb);
        }
      }
    }
    this.setState({
      documents,
      images,
      meta
    });
  }

  toBase64(buffer) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  render() {
    return (
      <div style={{ height: '100%', minHeight: '100%' }}>
        <Navbar />
        <div style={{ maxWidth: '90%', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center' }}>Available Documents</h2>
          <DocumentTable
            documents={this.state.documents}
            images={this.state.images}
            meta={this.state.meta}
          />
        </div>
      </div>
    );
  }
}

export default Documents;
